import { usePublishSiteMutation } from "@modules/site/create/Import/queries.generated"
import { useSiteRepositoryFieldsFragment } from "@modules/site/shared/fragments.generated"
import { useTracker, SegmentEventType } from "@modules/analytics"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { sourceControlProviderLabels } from "@modules/sourceControlProvider"

export function usePublishSite(siteId: string) {
  const { data: repositoryData } = useSiteRepositoryFieldsFragment(siteId)
  const { trackButtonClicked, trackSegment, trackAction } = useTracker()
  const [setError, errorAlert] = useTriggerErrorAlert()

  const [publishSiteMutation, mutationResult] = usePublishSiteMutation()

  const publish = (onSuccess: () => void) => {
    trackButtonClicked("Preview Site", {
      siteId,
      uiSource: `Create and setup site`,
    })

    const provider = repositoryData?.repository?.provider

    trackAction({
      eventType: `TRACK_EVENT`,
      name: `Created a Site`,
      valueString: provider ? sourceControlProviderLabels[provider] : "",
      siteId,
    })
    trackSegment({
      type: SegmentEventType.Track,
      event: "Created a Site",
      properties: {
        vcsType: provider ? sourceControlProviderLabels[provider] : "",
      },
    })

    publishSiteMutation({
      variables: {
        id: siteId,
        environmentVariables: [],
      },
    })
      .then(result => {
        if (result?.data?.publishSite) {
          onSuccess()
        }
      })
      .catch(err => setError(err))
  }

  return [publish, { ...mutationResult, errorAlert }] as const
}
